import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

export const Footer = () => {
  return (
    <footer className="footer mt-auto py-3">
      <div className="container text-center">
        <Row>
          <Col>
            <div className="d-flex justify-content-center flex-wrap">
              <a className="text-muted" href="https://www.multpl.com/s-p-500-pe-ratio" target="_blank" rel="noopener noreferrer">S&P 500 PE Ratio</a>
              <span className="text-muted mx-2">{'   '}&middot;{'   '}</span>
              <a className="text-muted" href="https://www.bamsec.com" target="_blank" rel="noopener noreferrer">BamSEC</a>
              <span className="text-muted mx-2">{'   '}&middot;{'   '}</span>
              <a className="text-muted" href="https://www.portfoliovisualizer.com" target="_blank" rel="noopener noreferrer">Portfolio Visualizer</a>
              <span className="text-muted mx-2">{'   '}&middot;{'   '}</span>
              <a className="text-muted" href="https://seekingalpha.com" target="_blank" rel="noopener noreferrer">Seeking Alpha</a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col><span className="text-muted">Copyright © InIn corp. All Rights Reserved.</span></Col>
        </Row>
      </div>
    </footer>
  )
}
